define('responsive-gameday/controllers/VideoAdvertisingViewController',['require','exports','module','GameDayCore','message-service/message-service','Responsive/controllers/OverlayViewController','../views/render/VideosViewRender','GameDayCore/GDControl/advertising/PageVisibilityManager','GameDayCore/GDControl/advertising/MidInningGamesManager','GameDayCore/GDModel/enums/events/EventTypes','jquery','GameDayCore/GDModel/enums/datasources/Datasources','../utils/ui-log','extant/extant','GameDayCore/GDUtil/window/WindowBridge','GameDayCore/GDUtil/resources/GDConfig','Responsive/util/renderComplete'],function(require, exports, module) {
    //(function (win, doc, undef, Re, GameDayUI, $GDC, $require) {
    // private vars go here
    var GDC = require("GameDayCore"),
        MessageService = require("message-service/message-service"),
        OverlayViewController = require("Responsive/controllers/OverlayViewController"),
        VideosViewRender = require( '../views/render/VideosViewRender' ),
        PageVisibilityManager = require("GameDayCore/GDControl/advertising/PageVisibilityManager"),
        MidInningGames = require("GameDayCore/GDControl/advertising/MidInningGamesManager"),
        EventTypes = require("GameDayCore/GDModel/enums/events/EventTypes"),
        $ = require("jquery"),
        Datasources = require("GameDayCore/GDModel/enums/datasources/Datasources"),
        Logg = require("../utils/ui-log"),
        exists = require("extant/extant"),
        WindowBridge = require("GameDayCore/GDUtil/window/WindowBridge"),
        GDConfig = require("GameDayCore/GDUtil/resources/GDConfig")
        renderComplete = require( "Responsive/util/renderComplete" );
    var Superclass;

    // constructor
    // Constructor
    function VideoAdvertisingViewController(opts, view) {
        var self = this,
            active = false,
            config = GDC.getGameData(Datasources.STATIC_RESOURCES),
            videoEnabled = opts.videoAdsEnabled = true;

        Superclass.constructor.call(this,opts,view);
        this.viewRender = new VideosViewRender();
        this.init(opts, view);
        this.referenceName = "videoAds";

        function handlePageVisibilityChanged(evt, evtArgs){
            var gdadplayer = document.getElementById('gdFlashVideoAdPlayer');
            Logg.log("VideoAdvertisingViewController : handlePageVisibilityChanged : " + PageVisibilityManager.getPageVisibility());
            if (!active || gdadplayer === null){
                return;
            }
            if (!! PageVisibilityManager.getPageVisibility()){
                gdadplayer.handleBrowserTabVisible();
            } else {
                gdadplayer.handleBrowserTabHidden();
            }
        }

        this.activate = function() {
			if (active) { return; }
            active = true;

            if (!MidInningGames.checkMidInningGames()) {
				setTimeout(function () {
                    self.loadView();
                    self.view.innerHTML = self.viewRender.renderPartial('videoAdsView',{ });

                    // contain this modal within the app window, not the entire page
                    // rootView.getView().appendChild(self.view.parentNode);
                    // view.presentFloatingModalViewController(self);

                    if (GDConfig.videoAdsEnabled === true) {
						Logg.log("VIDEO AD, I SAY: APPEAR!");
						self.addSwf()
					} else {
						Logg.log("VIDEO AD, I SAY: DON'T BOTHER! GO WITH A STILL");
						self.addStill();
					}

                }, 5000);
            } else {
				Logg.log("forgoing a video ad in favor of *trying* to launch a branded mid-inning game");
                self.loadView();
                var _mainRenderer = self.mainRender || Wax.get("videoAdsTemplate");
                self.view.innerHTML = _mainRenderer({ });

                renderComplete(function(){
                    var $win = $(window),
                        iframe = $('<iframe/>'),
                        target = $('#gdFlashVideoAdPlayer',self.view),
                        container = target.parent(),
                        params = [],
                        data = GDC.getGameData(),
                        mig = data.midInningGames.slot,
                        ls  = data.linescore,
                        url = '/shared/components/gameday/v7/game_frame_v2.html',
                        handleClose = function(e){
                            var data = e.data || e.originalEvent.data;
                            if(data==='mig:close'){
                                $win.off('message',handleClose);
                                GDC.endCommercialBreak();
                            }
                        };

                    params.push("event_id="+ls.game_media.calendar_event_id);
                    params.push("game_id="+ls.id);
                    params.push("game_pk="+ls.game_pk);
                    params.push("type="+mig.game.type);
                    params.push("sponsor="+mig.game.sponsor);

                    iframe.on('load error',function(){
                        container.css('opacity','1.0');
                        GDC.beginCommericalBreak();
                    })
                    $win.on("message",handleClose);
                    iframe.attr('src',url + "#" + params.join(','));
                    container.addClass('mig');
                    target.append(iframe);
                })
            }
        };

        this.deactivate = function() {
            if (!active) { return; }
            self.exit();
            // rootView.getView().removeChild(self.view.parentNode);
            // view.dismissFloatingModalViewController();
            active = false;
            Logg.log("VIDEO AD, I SAY: DISAPPEAR!");
        };

        function handleCompanion(payload, evt) {
            var tude = config.getAuditude(),
                compBan = (exists(tude)) ? tude.jsCompanionFunction : undefined,
                defaultComp = (exists(tude)) ? tude.jsDefaultCompanionFunction : undefined;

            if (exists(payload)) {
                var ads = escape(JSON.stringify(payload));
                WindowBridge.dispatchMessage("updateCompanionAd~" + ads);
            } else if (defauxltComp) {
                WindowBridge.dispatchMessage("defaultCompanionAd");
            }
        }

        MessageService.publish("registerViewComponent", self);
        MessageService.addListener(EventTypes.PAGE_VISIBILITY_CHANGED, handlePageVisibilityChanged);
    }

    // proceed with prototypical inheretance
    OverlayViewController.spawn(VideoAdvertisingViewController).define({
        addSwf: function() {
            var boxscore = GDC.getGameData("boxscore").boxscore;

			var contentKey = boxscore.gamePK + "pre-roll";

            Logg.log("media id for Auditude is: " + contentKey);
            //copy the custom props into the flashvars
            var flashVars = {
                "contentKey" :  contentKey,
                "onAdBreakStartedCallback" : "window.GDC.beginCommericalBreak",
                "onAdBreakCompleteCallback" :  "window.GDC.endCommercialBreak",
                "jsCompanionFunction" :  "window.GDC.handleCommercialCompanionAd",
                "jsDefaultCompanionFunction":  "window.GDC.handleCommercialCompanionAd",
                "browserTabVisible": PageVisibilityManager.getPageVisibility(),
                "homeTeamId" : boxscore.home_id,
                "awayTeamId" : boxscore.away_id,
                "default_muted" : "false",
                "enabled" : "true",
                "volume" : ".5",
                "muteCookieExpiration" : "86400000"
            };

			var flashParams = {
                "wmode":  "transparent",
                "scale": "noscale",
                "align": "top"
            };

			swfobject.embedSWF(
                "/shared/components/gameday/gdapp/release/shared/swf/GamedayHTMLStandaloneAdPlayer.swf",
                "gdFlashVideoAdPlayer",
                "512",
                "288",
                "9",
                "/shared/flash/express_install/playerProductInstall.swf",
                flashVars,
                flashParams,
                { }
            );

        },

        addStill: function() {
            Logg.warn("still ad? Wait, what?");
        }
    });

    Superclass = VideoAdvertisingViewController.superclass;
    return VideoAdvertisingViewController;

});
